var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.81145 0.534486C10.1213 0.192255 10.5415 0 10.9797 0C11.4179 0 11.8381 0.192255 12.1479 0.534486L21.4955 10.8614C21.6534 11.0298 21.7792 11.2312 21.8658 11.454C21.9524 11.6767 21.998 11.9162 21.9999 12.1586C22.0018 12.401 21.96 12.6414 21.877 12.8657C21.7939 13.0901 21.6712 13.2939 21.516 13.4653C21.3609 13.6367 21.1764 13.7723 20.9733 13.8641C20.7702 13.9558 20.5526 14.002 20.3332 13.9999C20.1138 13.9978 19.897 13.9475 19.6954 13.8518C19.4938 13.7561 19.3115 13.617 19.1591 13.4427L10.9797 4.4064L2.80033 13.4427C2.48869 13.7752 2.07129 13.9592 1.63804 13.9551C1.20479 13.9509 0.790344 13.7589 0.483976 13.4205C0.177608 13.082 0.00382614 12.6241 6.10352e-05 12.1455C-0.00370407 11.6668 0.162849 11.2057 0.463846 10.8614L9.81145 0.534486Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up_arrow.9e9ad689d3aac2a0ddb83a3fd9dd7b95.svg";
export { ForwardRef as ReactComponent };